import React, { useState, useEffect } from 'react'
import 'antd/lib/select/style/index.css'
import { Card, CardBody, Col, Row } from "reactstrap"
import { Pagination, message } from "antd"
import FilterUpdateAt from './filter/FilterUpdateAt'
import FilterInput from './filter/FilterInput'
import ProductProcessTable from './table/ProductProcessTable'
import UseDebounce from './helpers/UseDebounce'
import { getListProductionProcess, getListProductionStage } from '../../../services/api/apiSku'
import { getListPartner } from '../../../services/api/3dApi'
import { STATUS } from './helpers/FilterLists'
import { Link } from 'react-router-dom'

const ProductionProcessPage = () => {
    const [listProcess, setListProcess] = useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [pushAt, setPushAt] = useState('')
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [filters, setFilters] = useState({})
    const [stages, setStages] = useState([])
    const [partners, setPartners] = useState([])

    const { name, status, partner, stage } = filters

    const deBounceSearchName = name === '' ? UseDebounce(name, 0) : UseDebounce(name, 500)

    useEffect(() => {
        _fetchListPartner()
        _fetchListStages()
    }, [])

    useEffect(() => {
        _fetchListProductProcess()
    }, [deBounceSearchName, pushAt, partner, status, page, limit, stage])

    const _fetchListProductProcess = async () => {
        setLoading(true)
        setError('')
        setListProcess([])
        try {
            const payload = {
                page,
                pageSize: limit,
            }

            if (!!deBounceSearchName) payload.name = deBounceSearchName.trim()

            if (!!status) payload.is_active = status
            if (!!partner) payload.partner = partner
            if (!!stage) payload.stage = stage


            if (!!pushAt && !!pushAt.pushed_at) {
                const { from, to } = Object.assign({}, pushAt.pushed_at)

                if (!!from) payload.from = from
                if (!!to) payload.to = to
            }

            const { data: response } = await getListProductionProcess(payload)
            const { data, success, message: mess } = Object.assign({}, response)
            if (!success) return setError(mess)

            const { result, total } = Object.assign({}, data)
            setListProcess(result)
            setTotal(total)

        } catch (error) {
            setError(error?.message)
        } finally {
            setLoading(false)
        }
    }

    const _fetchListPartner = async () => {
        try {
            const { data, success, message: mess } = await getListPartner()
            if (!success) return message.error(mess)
            const { partners } = Object.assign({}, data)

            const listPartners = partners.map(i => ({
                label: i.name,
                value: i._id,
            }))
            
            setPartners(listPartners)

        } catch (error) {
            message.error(error.message)
        }
    }

    const _fetchListStages = async () => {
        try {
            const { data: res } = await getListProductionStage({ limit: 100 })
            const { data, success, message: mess } = Object.assign({}, res)
            if (!success) return message.error(mess)

            const listStages = data.stages.map(i => ({
                label: `${i.name} - ${i.partner.name}`,
                value: i._id
            }))
            setStages(listStages)

        } catch (error) {
            message.error(error.message)
        }
    }

    const handleChangeFilter = (field, value) => {
        setFilters({
            ...filters,
            [field]: value
        })
        setPage(1)
    }

    const handlePageChange = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _handleChangePushAt = filter => {
        setPushAt({ ...filter })
        setPage(1)
    }

    return (
        <div className='IssuesManagementPage'>
            <Card>
                <div className="CardHeader card-header header-elements-inline">
                    <div className="header-elements d-flex justify-content-between align-items-center w-100">
                        <h1 className='card-title'>Quản lý quy trình sản xuất</h1>
                        <div className="actions">
                            <Link to="/production-process-create">
                                <button className='btn btn-primary'>
                                    Thêm mới
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <CardBody>
                    <div className="IssueFilters mb-3 p-3">
                        <Row className="mb-2" >
                            <Col span={2} className="mr-1">
                                <label htmlFor="" className='mb-1 font-weight-bold'>Quy trình</label>
                                <FilterInput
                                    placeholder="Tìm kiếm: Quy trình"
                                    onChange={handleChangeFilter}
                                    field='name'
                                />
                            </Col>
                            <Col span={2} className="mr-1">
                                <label htmlFor="" className='mb-1 font-weight-bold'>Công đoạn</label>
                                <FilterInput
                                    options={stages}
                                    placeholder="Chọn công đoạn"
                                    onChange={handleChangeFilter}
                                    field='stage'
                                    type='select'
                                    showSearch={true}
                                />
                            </Col>
                            <Col span={2} className="mr-1">
                                <label htmlFor="" className='mb-1 font-weight-bold' style={{ whiteSpace: 'nowrap' }}>Đối tác sản xuất</label>
                                <FilterInput
                                    options={partners}
                                    placeholder="Chọn đối tác sản xuất"
                                    onChange={handleChangeFilter}
                                    field='partner'
                                    type='select'
                                />
                            </Col>
                            <Col span={2} className="mr-1">
                                <label htmlFor="" className='mb-1 font-weight-bold'>Trạng thái</label>
                                <FilterInput
                                    options={STATUS}
                                    placeholder="Chọn trạng thái"
                                    onChange={handleChangeFilter}
                                    field='status'
                                    type='select'
                                />
                            </Col>
                            <Col span={2} className="mr-1">
                                <label htmlFor="" className='mb-1 font-weight-bold'>Ngày cập nhật</label>
                                <FilterUpdateAt
                                    handleChangeDate={_handleChangePushAt}
                                    updated={pushAt}
                                    placeholder={['Bắt đầu', 'Kết thúc']}
                                    field="pushed_at"
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="d-flex justify-content-end mb-3">
                        <div className='d-flex align-items-center justify-content-end'>
                            <div className='d-flex align-items-center ml-1'>
                                <div className='ml-3'>Tổng: <span className='font-weight-bold'>{total || 0}</span></div>
                            </div>
                        </div>
                    </div>

                    <ProductProcessTable
                        listIssues={listProcess}
                        loading={loading}
                        error={error}
                        reload={_fetchListProductProcess}
                    />

                    <Pagination
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        className='text-right mt-3'
                        pageSize={limit}
                        showSizeChanger
                        current={page}
                        total={total}
                    />
                </CardBody>
            </Card>
        </div >
    )
}

export default ProductionProcessPage